import React from "react";
import { Link } from "react-router-dom";
import { Slide } from 'react-slideshow-image';
import Gallery1 from '../images/gallery1.jpg'
import Gallery2 from '../images/gallery2.jpg'
import Gallery3 from '../images/gallery3.jpg'

 
const properties = {
  duration: 4000,
  transitionDuration: 500,
  infinite: true,
  indicators: true,
  arrows: false,
  onChange: (oldIndex, newIndex) => {
  }
}



export default function HomeSlider() {

  return (
    <div id="gallery-div">
       <Slide {...properties}>
       <div class="slider-box">
          <img
            className="slider-images"
            src={Gallery1}
          />
          <p className="bottom-left-headline">
            A Parisian Brunch <br></br>in the West Village
          </p>
          <Link className="bottom-left-text" to="/gallery"><p>Take a look ➜</p></Link>
          </div>
        <div class="slider-box">
          <img
            className="slider-images"
            src={Gallery2}
          />
          <p className="bottom-left-headline">
            From a tasty brunch <br></br>to a romantic dinner
          </p>
          <Link className="bottom-left-text" to="/menu"><p>See our dishes ➜</p></Link>
        </div>
        <div class="slider-box">
          <img
            className="slider-images"
            src={Gallery3}
          />
          <p className="bottom-left-headline">
            Freshly baked goods, <br></br>Paris style
          </p>
          <Link className="bottom-left-text" to="/gallery"><p>See our creations ➜</p></Link>
        </div>
        </Slide>
      
    </div>
  );
}
